const anomalies = {
    title: 'Anomaly Events',
    severity: 'Severity',
    status: 'Status',
    type: 'Type',
    path: 'Path',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    markResolved: 'Mark Resolved',
    noMatchingAnomalies: 'No matching anomaly events',
    resolveDialogTitle: 'Mark anomaly as resolved',
    resolveNote: 'Resolution note (optional)',
    totalCount: 'Total {{total}} items',
    fetchFailed: 'Failed to fetch anomaly events: {{message}}',
    resolveFailed: 'Failed to mark resolved: {{message}}',
    severityValues: {
      low: 'low',
      medium: 'medium',
      high: 'high',
      critical: 'critical',
    },
  };

export default anomalies;
